<!-- This component is designed to lazily load the image / picture when it is needed. Why not use native browser lazy loading?
We have several instances where the image ratio is not fixed, but e.g. the height is fixed and wdith depends on screen size
Chrome currently has an issue with load triggering in these situations
https://stackoverflow.com/questions/67390705/native-loading-lazy-causes-some-images-not-to-load -->
<template>
   <div ref="$target" :class="{ 'opacity-0': !state.isOnScreen }" class="transition-opacity">
      <slot v-if="state.isOnScreen"></slot>
   </div>
</template>

<script setup lang="ts">
// declarations
// -----------------------------------------
const settingsStore = useSettingsStore();
const $target = ref(null);
// state
const state = reactive({
   isOnScreen: false,
   observer: null,
});

// lifecycle
// -----------------------------------------
onBeforeUnmount(() => {
   state.observer.disconnect();
});

onMounted(() => {
   if ($target.value) {
      // No options are passed, only callback, as the defaults are exactly what we need
      state.observer = new IntersectionObserver(onElementObserved);
      state.observer.observe($target.value);
   }
});

// Watch for changes in lazyLoadEnabled
watch(
   () => settingsStore.lazyLoadEnabled,
   (isEnabled) => {
      if (!isEnabled) {
         state.isOnScreen = true;
         state.observer.unobserve($target.value);
      }
   }
);

// methods
// -----------------------------------------
const onElementObserved = (entries) => {
   if (entries[0].isIntersecting) {
      // Load the image, stop observing
      state.isOnScreen = true;
      state.observer.unobserve($target.value);
   }
};
</script>
